<template>
    <div class="login-old-domain-warning img-side">
        <img src="https://www.sokuji.tw/_files/app-use/sokuji_color.svg" class="logo-img" />
        <div class="title">ahoo 已更名為 Sokuji</div>
        <div class="description">提醒您，https://app.ahoo.tw 網域將於 9/20 將關閉，請您改用新網址進入系統：</div>
        <a :href="url" class="link">https://app.sokuji.tw</a>
    </div>
</template>
<script>
export default {
    props: {
        company: {
            type: String,
            default: null,
        },
        email: {
            type: String,
            default: null,
        },
    },
    computed: {
        url() {
            const urlQuery = [];
            if (this.company) {
                urlQuery.push(`company_id=${this.company}`);
            }
            if (this.email) {
                urlQuery.push(`email=${this.email}`);
            }
            const basetUrl = 'https://app.sokuji.tw/login';
            if (urlQuery.length > 0) {
                return `${basetUrl}?${urlQuery.join('&')}`;
            }
            return basetUrl;
        },
    },
};
</script>
<style lang="scss">
    .login-old-domain-warning.img-side {
        display: block !important;
        padding-left: 50px !important;
        padding-right: 50px !important;
        border-bottom-right-radius: 20px !important;
        width: auto !important;
        padding: 30px;
        color: #fff;

        @media (min-width: 992px) {
            display: table-cell !important;
            width: 400px !important;
            border-bottom-right-radius: 0px !important;
        }

        .logo-img {
            display: block;
            width: 60%;
            margin: 40px auto;
        }

        .title {
            text-align: center;
            font-size: 17pt;
            font-weight: bold;
            margin-bottom: 25px;
        }

        .description {
            font-size: 11pt;
        }

        .link {
            display: block;
            text-align: center;
            margin-top: 25px;
            padding: 8px 10px 10px 10px;
            background-color: rgba(255,255,255,0.2);
            border-radius: 6px;
            color: #fff;
            font-weight: bold;
            font-size: 14pt;
            line-height: 20pt;
            transition: 0.2s;

            &:hover {
                background-color: rgba(255,255,255,0.25);
            }
        }
    }
</style>
